module.exports = "/fonts/fa-solid-900.ttf?1ab236ed440ee51810c56bd16628aef0";